module.exports = __webpack_public_path__ + "img/75f242d.png";